import { isUserPermitted } from '../auth/components/UserRoleGuard/utils';
import { INTERNAL_USER_ROLES } from '../pages/constants';

export type FilterHelpLinksForUserParams = {
  links: HelpButtonLink[];
  userRoles: UserRole[];
  helpLinkLabelToHide: string;
};

export const filterHelpLinksForUser = ({
  links,
  userRoles,
  helpLinkLabelToHide,
}: FilterHelpLinksForUserParams): HelpButtonLink[] => {
  const isInternalUser = isUserPermitted(userRoles, INTERNAL_USER_ROLES);

  if (isInternalUser) {
    return links;
  }

  return links.filter((link) => link.label !== helpLinkLabelToHide);
};
